import api from './api';

export const validate = (email) => {
	let error = '';
	if (isNaN(email)) {
		if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
			error = 'Please enter a valid Email Address.';
		}
	}
	return error;
};

export const validatePhoneNumber = (phoneNumber) => {
	let error = '';
	if (phoneNumber && phoneNumber.length < 10) {
		error = 'Please enter 10 digits.';
	}
	return error;
};

export const subscribe = (formData, successCallback, errcallback) => {
	if (window && window.getGclid && window.getGclid()) {
		formData['gclid'] = window.getGclid();
	}

	api
		.post('/save_subscription/', formData)
		.then((response) => {
			successCallback(response);
		})
		.catch((error) => {
			errcallback(error);
		});
};

export const subscribeV1 = (formData, successCallback, errcallback) => {
	if (window && window.getGclid && window.getGclid()) {
		formData['gclid'] = window.getGclid();
	}

	api
		.post('/v1/save_subscription/', formData)
		.then((response) => {
			successCallback(response);
		})
		.catch((error) => {
			errcallback(error);
		});
};

export const downloadResource = (formData, successCallback, errcallback) => {
	if(window && window.getGclid && window.getGclid()) {
		formData['gclid'] = window.getGclid()
	}
	api
		.post('/save_hubspot_form/', formData)
		.then((response) => {
			successCallback(response);
		})
		.catch((error) => {
			errcallback(error);
		});
};

export const saveForm = (formData, successCallback, errcallback) => {
	if(window && window.getGclid && window.getGclid()) {
		formData['gclid'] = window.getGclid()
	}

	api
		.post('/save_website_form/', formData)
		.then((response) => {
			successCallback(response);
		})
		.catch((error) => {
			errcallback(error);
		});
};

export const saveContact = (formData, successCallback, errcallback) => {
	if(window && window.getGclid && window.getGclid()) {
		formData['gclid'] = window.getGclid()
	}

	api
		.post('/save_hubspot_form/', formData)
		.then((response) => {
			successCallback(response);
		})
		.catch((error) => {
			errcallback(error);
			
		});
};
